import type { ReactNode, RefObject } from 'react';
import { ResultsFiltersSheet } from '../../shared/results_page/results_filters_sheet.js';
import { BusResultsFilters, type BusResultsFiltersCopy } from './bus_results_filters.js';
import type { BusFilterableOffer, BusResultsFilterValue } from './bus_results_rules.js';

/** A coluna de cortes do ônibus na folha do palco estreito — o rascunho só
 *  vale no "Aplicar filtros", como no carro. */
export function BusResultsFiltersSheet({
  open,
  onOpenChange,
  returnFocusTo,
  offers,
  currency,
  value,
  copy,
  applyLabel,
  locked,
  onApply,
}: {
  readonly open: boolean;
  readonly onOpenChange: (open: boolean) => void;
  readonly returnFocusTo: RefObject<HTMLElement | null>;
  readonly offers: readonly BusFilterableOffer[];
  readonly currency: string;
  readonly value: BusResultsFilterValue;
  readonly copy: BusResultsFiltersCopy;
  readonly applyLabel: string;
  readonly locked: boolean;
  readonly onApply: (value: BusResultsFilterValue) => void;
}): ReactNode {
  return (
    <ResultsFiltersSheet
      open={open}
      onOpenChange={onOpenChange}
      returnFocusTo={returnFocusTo}
      value={value}
      label={copy.filtersLabel}
      applyLabel={applyLabel}
      locked={locked}
      onApply={onApply}
    >
      {({ draft, setDraft, close }) => (
        <BusResultsFilters
          offers={offers}
          currency={currency}
          value={draft}
          copy={copy}
          locked={locked}
          frame={false}
          dismiss="close"
          onChange={setDraft}
          onCollapse={close}
        />
      )}
    </ResultsFiltersSheet>
  );
}
